import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

function useQueryWithHash() {
   const { search, hash } = useLocation()

   return useMemo(() => {
      const params = new URLSearchParams(search)
      const originalGet = params.get.bind(params)

      // Override the get method
      params.get = (key: string) => {
         const value = originalGet(key)
         // Only append hash to redirectUrl
         if (key === 'redirectUrl' && value && hash) {
            return value + hash
         }
         return value
      }

      return params
   }, [search, hash])
}

export default useQueryWithHash